import React from 'react';

const LogoLoop: React.FC = () => {
    return (
        <div className="bg-gray-100 rounded-sm">
            {/* <h3 className='text-center text-base text-gray-600'>As Seen In</h3> */}
            <div className="wrapper-loop">
                <div className="item item1">
                    <img src="/img/Foxnews.svg" alt="Fox News" className="h-20 w-auto" />
                </div>
                <div className="item item2">
                    <img src="/img/Mirror.png" alt="The Mirror" className="h-12 w-auto" />
                </div>
                <div className="item item3">
                    <img src="/img/NBC-C.svg" alt="NBC" className="h-20 w-auto" />
                </div>
                {/* Add other items if needed */}
            </div>
        </div>
    );
};

export default LogoLoop;
